module.exports = __webpack_public_path__ + "fontawesome-webfont.97493d3f11c0a3bd5cbd.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/vendors/ng-prime/fonts/fontawesome-webfont.woff2?v=4.3.0
// module id = ../../../../../src/assets/vendors/ng-prime/fonts/fontawesome-webfont.woff2?v=4.3.0
// module chunks = 2